import Styled from 'styled-components';

const CommandPanel = Styled.div`
  display: flex;
  margin-bottom: 5px
`;

export default CommandPanel;
